export default __webpack_public_path__ + "static/media/Manifestacao-dos-Professores.b82ca189.jpg";